import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useCreateProduct() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: {
      organisationId: string;
      product: string;
      description: string | null;
      createdByEmail: string;
      source?: string;
      identifierType?: string;
    }) => {
      // 1. Insert into products table
      const { error: productError } = await supabase
        .from("products" as any)
        .insert({
          organisation_id: params.organisationId,
          product: params.product,
          description: params.description,
          created_by_email: params.createdByEmail,
          source: params.source ?? "po_import",
          identifier_type: params.identifierType ?? "SKU",
        });
      if (productError) throw productError;
    },
    onSuccess: (_, params) => {
      queryClient.invalidateQueries({
        queryKey: ["sku-mappings", params.organisationId],
      });
      queryClient.invalidateQueries({
        queryKey: ["available-skus", params.organisationId],
      });
    },
  });
}
